import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const onSale = product.compareAt && product.price && product.compareAt > product.price;
  const noPrice = product.price === null || product.price === undefined;
  const comingSoon = product.status === 'coming-soon';
  const soldOut = !comingSoon && (product.in_stock === false || product.stock === 0);
  const unavailable = comingSoon || noPrice || soldOut;
  const statusLabel = (comingSoon || noPrice) ? 'Coming Soon' : 'Out of Stock';
  return (
    <div className="group card-glass rounded-2xl overflow-hidden hover-lift flex flex-col">
      <Link to={`/product/${product.id}`} className="block relative overflow-hidden">
        <div className="aspect-square overflow-hidden bg-[#120d10]">
          <img src={product.image} alt={product.name} loading="lazy" className={`h-full w-full object-cover transition-transform duration-700 group-hover:scale-110 ${unavailable ? 'opacity-70' : ''}`} />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0708]/70 via-transparent to-transparent" />
        {product.badge && (<span className="absolute top-3 left-3 text-[10px] tracking-[0.15em] uppercase px-3 py-1 rounded-full bg-gradient-to-r from-[#d6197d] to-[#ff4da6] text-white font-jost">{product.badge}</span>)}
        {unavailable && (<span className="absolute top-3 left-3 text-[10px] tracking-[0.15em] uppercase px-3 py-1 rounded-full bg-[#0a0708]/80 border border-[#d4af37]/40 text-[#f0d582] font-jost">{statusLabel}</span>)}
        {onSale && (<span className="absolute top-3 right-3 text-[10px] tracking-widest uppercase px-2.5 py-1 rounded-full bg-[#d4af37] text-[#0a0708] font-jost font-semibold">Sale</span>)}
      </Link>
      <div className="p-5 flex flex-col flex-1">
        <Link to={`/product/${product.id}`}>
          <h3 className="font-cormorant text-2xl text-[#f5ecd9] leading-tight hover:text-[#ff4da6] transition-colors">{product.name}</h3>
        </Link>
        <p className="font-jost text-xs text-[#f5ecd9]/50 mt-1 mb-4 flex-1">{product.tagline || product.summary}</p>
        <div className="flex items-center justify-between">
          <span className="flex items-baseline gap-2">
            {noPrice ? (<span className="font-cinzel text-sm text-[#f0d582]">Coming Soon</span>) : (<span className="font-cinzel text-lg text-gold-gradient">${product.price.toFixed(2)}</span>)}
            {onSale && (<span className="text-xs text-[#f5ecd9]/40 line-through">${product.compareAt.toFixed(2)}</span>)}
          </span>
          <button onClick={() => !unavailable && addItem(product)} disabled={unavailable} className={`flex items-center gap-1.5 rounded-full px-4 py-2 text-xs font-medium ${unavailable ? 'bg-white/10 text-[#f5ecd9]/40 cursor-not-allowed' : 'text-[#0a0708] bg-gradient-to-r from-[#d4af37] to-[#f0d582] btn-gold'}`}>
            {unavailable ? statusLabel : (<><Plus className="h-3.5 w-3.5" /> Add</>)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
